module.exports = __webpack_public_path__ + "static/img/2.ab989ad1.gif";